import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { defineComponent as _defineComponent } from 'vue';
import { EnumActivityRiskProfile, EnumActivityType, useAddActivityMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'AddActivity',
  props: {
    buttonClass: String,
    valueChainId: String,
    prevActivity: Object,
    // used to calculate which type to show
    nextActivity: Object // used to calculate which type to show
  },
  setup: function setup(__props) {
    var props = __props;
    var riskProfile = ref(EnumActivityRiskProfile.Significant);
    var name = ref('');
    var type = ref();
    var _useAddActivityMutati = useAddActivityMutation(),
      addActivity = _useAddActivityMutati.mutate,
      loading = _useAddActivityMutati.loading;
    var topAttrs = useAttrs();
    var getActivityLabel = function getActivityLabel(typeValue) {
      switch (typeValue) {
        case EnumActivityType.Upstream:
          return 'Upstream';
        case EnumActivityType.Own:
          return 'Own';
        case EnumActivityType.Downstream:
          return 'Downstream';
        default:
          return '';
        // Fallback for undefined type values
      }
    };
    var EnumActivityRank = _defineProperty(_defineProperty(_defineProperty({}, EnumActivityType.Upstream, 3), EnumActivityType.Own, 2), EnumActivityType.Downstream, 1);
    var sortOrder = computed(function () {
      var _props$prevActivity, _props$nextActivity;
      return ((((_props$prevActivity = props.prevActivity) === null || _props$prevActivity === void 0 ? void 0 : _props$prevActivity.sortOrder) || 0) + (((_props$nextActivity = props.nextActivity) === null || _props$nextActivity === void 0 ? void 0 : _props$nextActivity.sortOrder) || 100)) / 2;
    });
    var infoDialog = ref(false);
    var allowedTypes = computed(function () {
      var _props$prevActivity2, _props$nextActivity2, _allowedActivityTypes;
      var prevType = ((_props$prevActivity2 = props.prevActivity) === null || _props$prevActivity2 === void 0 ? void 0 : _props$prevActivity2.type) || EnumActivityType.Upstream; // Default to Upstream if no previous activity
      var nextType = ((_props$nextActivity2 = props.nextActivity) === null || _props$nextActivity2 === void 0 ? void 0 : _props$nextActivity2.type) || EnumActivityType.Downstream; // Assume nextActivityType is provided, default to Upstream

      var minRank = Math.min(EnumActivityRank[prevType], EnumActivityRank[nextType]);
      var maxRank = Math.max(EnumActivityRank[prevType], EnumActivityRank[nextType]);
      var allowedActivityTypes = [];
      Object.entries(EnumActivityRank).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          type = _ref2[0],
          rank = _ref2[1];
        if (rank >= minRank && rank <= maxRank && allowedActivityTypes.length < 2) {
          allowedActivityTypes.push({
            value: type,
            label: getActivityLabel(type)
          });
        }
      });

      // Set the 'type.value' assuming you are using a ref to manage some state, needs clarification
      type.value = allowedActivityTypes === null || allowedActivityTypes === void 0 ? void 0 : (_allowedActivityTypes = allowedActivityTypes[0]) === null || _allowedActivityTypes === void 0 ? void 0 : _allowedActivityTypes.value;
      return allowedActivityTypes;
    });
    return {
      __sfc: true,
      riskProfile: riskProfile,
      name: name,
      type: type,
      addActivity: addActivity,
      loading: loading,
      topAttrs: topAttrs,
      props: props,
      getActivityLabel: getActivityLabel,
      EnumActivityRank: EnumActivityRank,
      sortOrder: sortOrder,
      infoDialog: infoDialog,
      allowedTypes: allowedTypes,
      EnumActivityRiskProfile: EnumActivityRiskProfile,
      EnumActivityType: EnumActivityType
    };
  }
});